import React, { useEffect, useState } from "react";

import { Box, Text } from "@wix/design-system";
import { InfoCircle } from "@wix/wix-ui-icons-common";
import FaireProduct from "../../models/faire-product";

type SimilarSkuExistsParams = {
  selectedProductId: string;
  showConirmationForUploadToFaire?: boolean;
  wixProducts?: any[];
};

const SimilarSkuExists = ({
  selectedProductId,
  showConirmationForUploadToFaire,
  wixProducts,
}: SimilarSkuExistsParams) => {
  const product = wixProducts?.filter((item: any) => item?.productId === selectedProductId);
  const [similarSkuExist, setSimilarSkuExist] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  let variants = (product && product[0]?.variants?.map((item: any) => item?.sku)) ?? [];
  let sku = product && product[0]?.sku ? [product[0].sku] : variants;

  const checkIfSkuExists = () => {
    setLoading(true);
    FaireProduct.checkProductWithSameSkuExists({ sku })
      .then((response: any) => {
        response?.message !== "Similar Sku Exists in Faire" ? setSimilarSkuExist(false) : setSimilarSkuExist(true);
      })
      .catch((error) => setSimilarSkuExist(false))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (showConirmationForUploadToFaire === true) {
      checkIfSkuExists();
    }
  }, [showConirmationForUploadToFaire]);

  const similarSkuComponent = similarSkuExist && (
    <Box verticalAlign="middle">
      <InfoCircle color="red" />
      <Text size="small" skin="error">
        Product with similar sku already exists on Faire
      </Text>
    </Box>
  );

  return <>{!loading && similarSkuComponent}</>;
};

export default SimilarSkuExists;
